import { render, staticRenderFns } from "./Journey.vue?vue&type=template&id=60116b0c&scoped=true"
import script from "./Journey.vue?vue&type=script&lang=js"
export * from "./Journey.vue?vue&type=script&lang=js"
import style0 from "./Journey.vue?vue&type=style&index=0&id=60116b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60116b0c",
  null
  
)

export default component.exports